import FilaProducto from './FilaProducto';
export default FilaProducto;